import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, type LazyComponent, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "HybridspaceDevPanel" */ "./lazyIndex"), { name: "HybridspaceDevPanel" });

export const DevPanel: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.DevPanel);
